module.exports = __webpack_public_path__ + "static/media/financepic3.2a7eed27.png";